export default __webpack_public_path__ + "static/media/ic-activities-db.9221fc49.svg";